import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import IconButton from "@mui/material/IconButton";
import Hexapi from "../usefulcomps/HexAPI/Hexapi";
import Logo from "../Images/nahatalogo.jpeg";
import Swal from "sweetalert2";

export default function NahataEnquiry() {
  const [agentId, setAgentId] = useState("");
  const [state, setState] = useState("");
  const [City, setCity] = useState("");
  const [LeadTypeID, setLeadType] = useState("");
  const [typeofEnquiries, setTypeofEnquiries] = useState([]);
  const [agents, setagents] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [LeadTypeOptions, setLeadTypeOptions] = useState([]);
  const [NatureOfBusiness, setNatureOfBusiness] = useState([]);
  const [isDetailsFetched, setIsDetailsFetched] = useState(false);

  const [enquiries, setEnquiries] = useState([
    {
      type: "",
      quantity: "",
      dgRating: "",
      panelType: "",
      specs: "",
      dgRatingOptions: [],
      panelTypeOptions: [],
    },
  ]);

  const [searchType, setSearchType] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [customerDetails, setCustomerDetails] = useState({
    companyName: "",
    contactPerson: "",
    contactNumber: "",
    officeAddress: "",
    siteAddress: "",
    natureOfBusiness: "",
    email: "",
    state: "",
    city: "",
    pincode: "",
    gstnumber: "",
  });
  const [searchErrors, setSearchErrors] = useState({});

  useEffect(() => {
    const setAgentIdFromUrl = () => {
      const params = new URLSearchParams(window.location.search);
      const agentId = params.get("agentid");
      if (agentId) {
        setAgentId(agentId);
        getdata(agentId);
      } else {
        console.log("No agentid found in URL");
      }
    };

    setAgentIdFromUrl();
  }, []);

  // Auto-fetch details when contact number is 10 digits
  useEffect(() => {
    if (
      customerDetails.contactNumber.length === 10 &&
      /^[0-9]{10}$/.test(customerDetails.contactNumber)
    ) {
      setSearchType("ContactNumber");
      setSearchValue(customerDetails.contactNumber);
      fetchDetails(customerDetails.contactNumber);
    } else if (customerDetails.contactNumber.length < 10) {
      setIsDetailsFetched(false);
    }
  }, [customerDetails.contactNumber]);

  const getdata = (AgentID) => {
    let obj = {
      query: `[dbo].[CRM_Proc_CustomerEnquiry_GetData]@AgentID='{0}'`,
      queryArr: [`${AgentID}`],
    };
    console.log("getdata");
    Hexapi(obj)
      .then((resp) => {
        console.log("GET Data:", resp);
        if (resp.agents) {
          setagents(resp.agents);
        }
        if (resp.typeofenquirys) {
          setTypeofEnquiries(resp.typeofenquirys);
        }
        if (resp.states) {
          setStateOptions(resp.states);
        }
        if (resp.leadtypes) {
          setLeadTypeOptions(resp.leadtypes);
        }
        if (resp.natureofbusiness) {
          setNatureOfBusiness(resp.natureofbusiness);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const StateOnChange = (selectedState) => {
    let obj = {
      query: `[dbo].[CRM_Proc_CustomerEnquiry_State_OnChange]@AgentID='{0}',@State='{1}'`,
      queryArr: [`${agentId}`, `${selectedState}`],
    };
    console.log("Fetching cities for:", selectedState);
    Hexapi(obj)
      .then((resp) => {
        console.log("Response State:", resp);
        if (resp && resp.cities) {
          setCityOptions(resp.cities);
        } else {
          setCityOptions([]);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const typeEnquiry = (index, selectedType) => {
    let obj = {
      query: `[dbo].[CRM_Proc_CustomerEnquiry_TypeOfEnquiry_OnChange]@AgentID='{0}',@TypeOfEnquiry='{1}'`,
      queryArr: [`${agentId}`, `${selectedType}`],
    };
    Hexapi(obj)
      .then((resp) => {
        console.log("Response for type Enquiry:", resp);
        const updated = [...enquiries];
        updated[index].dgRatingOptions = resp.ratings || [];
        updated[index].dgRating = "";
        updated[index].panelTypeOptions = [];
        updated[index].panelType = "";
        setEnquiries(updated);
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const rating = (index, selectedRating) => {
    let obj = {
      query: `[dbo].[CRM_Proc_CustomerEnquiry_Rating_OnChange]@AgentID='{0}',@Rating='{1}'`,
      queryArr: [`${agentId}`, `${selectedRating}`],
    };
    Hexapi(obj)
      .then((resp) => {
        console.log("DG Rating:", resp);
        const updated = [...enquiries];
        updated[index].panelTypeOptions = resp.panels || [];
        updated[index].panelType = "";
        setEnquiries(updated);
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchDetails = (contactNumber) => {
    let obj = {
      query: `[dbo].[CRM_Proc_CustomerEnquiry_FetchDetails] @ContactNumber='{0}'`,
      queryArr: [contactNumber],
    };
    Hexapi(obj)
      .then((resp) => {
        console.log("FetchDetails:", resp);

        if (resp && resp[""] && resp[""].length > 0) {
          const data = resp[""][0];

          if (data.state && !stateOptions.some((s) => s.state === data.state)) {
            setStateOptions((prev) => [...prev, { state: data.state }]);
          }
          if (data.city && !cityOptions.some((c) => c.city === data.city)) {
            setCityOptions((prev) => [...prev, { city: data.city }]);
          }

          setCustomerDetails({
            companyName: data.companyname || "",
            contactPerson: data.customername || "",
            contactNumber: contactNumber || "",
            officeAddress: data.officeaddress || "",
            siteAddress: data.siteaddress || "",
            natureOfBusiness: data.natureofbusiness || "",
            email: data.emailid || "",
            state: data.state || "",
            city: data.city || "",
            pincode: data.pincode || "",
            gstnumber: data.gstnumber || "",
          });
          setIsDetailsFetched(true);
        } else {
          // No existing customer found, enable fields for new entry
          setIsDetailsFetched(true);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setIsDetailsFetched(true);
      });
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const validatePhone = (phone) => {
    const re = /^[0-9]{10}$/;
    return re.test(phone);
  };

  const validatePhoneSearch = (phone) => {
    const re = /^[0-9]{10}$/;
    return re.test(phone);
  };

  const validatePincode = (pin) => {
    const re = /^[0-9]{6}$/;
    return re.test(pin);
  };

  const addEnquiry = () => {
    setEnquiries([
      ...enquiries,
      {
        type: "",
        quantity: "",
        dgRating: "",
        panelType: "",
        specs: "",
        dgRatingOptions: [],
        panelTypeOptions: [],
      },
    ]);
  };

  const removeEnquiry = (index) => {
    const updated = enquiries.filter((_, i) => i !== index);
    setEnquiries(updated);
  };

  const handleChange = (index, field, value) => {
    const updated = [...enquiries];
    updated[index][field] = value;
    setEnquiries(updated);
    if (field === "type") {
      typeEnquiry(index, value);
    }
    if (field === "dgRating") {
      rating(index, value);
    }
  };

  const handleSearch = () => {
    if (searchType && searchValue) {
      fetchDetails();
    }
  };

  const handleSubmit = () => {
    let newErrors = {};

    if (!customerDetails.companyName) {
      newErrors.companyName = "Company Name is required";
    }
    if (!customerDetails.contactPerson) {
      newErrors.contactPerson = "Contact Person is required";
    }

    if (!validatePhone(customerDetails.contactNumber)) {
      newErrors.contactNumber = "Enter a valid 10-digit number";
    }

    if (!validateEmail(customerDetails.email)) {
      newErrors.email = "Enter a valid email";
    }
    console.log(customerDetails.pincode);
    if (customerDetails.pincode != "") {
      if (!validatePincode(customerDetails.pincode)) {
        newErrors.pincode = "Enter a valid 6-digit pincode";
      }
    }
    enquiries.forEach((enq, i) => {
      if (!enq.type) {
        newErrors[`enquiryType_${i}`] = "Select enquiry type";
      }
      if (!enq.quantity || enq.quantity <= 0) {
        newErrors[`quantity_${i}`] = "Quantity must be greater than 0";
      }
      // Validate DG-specific fields if DG type is selected
      if (enq.type === "DG (Jackson Cummins)") {
        if (!enq.dgRating) {
          newErrors[`dgRating_${i}`] = "DG Rating is required";
        }
        if (!enq.panelType) {
          newErrors[`panelType_${i}`] = "Panel Type is required";
        }
      }
    });
    const firstErrorMessage = Object.values(newErrors)[0];
    Swal.fire({
      text: firstErrorMessage,
      icon: "error",
    });
    if (Object.keys(newErrors).length === 0) {
      enquiries.forEach((enq) => {
        let obj = {
          query: `[dbo].[CRM_Proc_CustomerEnquiry_Submit]
          @CompanyName='{0}',
          @CustomerName='{1}',
          @ContactNumber='{2}',
          @officeAddress='{3}',
          @SiteAddress='{4}',
          @NatureofBusiness='{5}',
          @Rating='{6}',
          @EmailID='{7}',
          @City='{8}',
          @State='{9}',
          @Pincode='{10}',
          @TypeofEnquiry='{11}',
          @OtherSpecifications='{12}',
          @AgentField='{13}',
          @Panel='{14}',
          @Qty='{15}',
          @LeadTypeID='{16}',
          @GSTNumber='{17}'`,
          queryArr: [
            `${customerDetails.companyName}`,
            `${customerDetails.contactPerson}`,
            `${customerDetails.contactNumber}`,
            `${customerDetails.officeAddress}`,
            `${customerDetails.siteAddress}`,
            `${customerDetails.natureOfBusiness}`,
            `${enq.dgRating || ""}`,
            `${customerDetails.email}`,
            `${customerDetails.city}`,
            `${customerDetails.state}`,
            `${customerDetails.pincode}`,
            `${enq.type}`,
            `${enq.specs || ""}`,
            `${agentId}`,
            `${enq.panelType || ""}`,
            `${enq.quantity || "0"}`,
            `${LeadTypeID}`,
            `${customerDetails.gstnumber}`,
          ],
        };

        Hexapi(obj)
          .then((resp) => {
            if (resp[""][0]["command"] == 1) {
              Swal.fire({
                text: resp[""][0]["msg"],
                icon: "success",
              }).then((result) => {
                setEnquiries([
                  {
                    type: "",
                    quantity: "",
                    dgRating: "",
                    panelType: "",
                    specs: "",
                    dgRatingOptions: [],
                    panelTypeOptions: [],
                  },
                ]);
                setCustomerDetails({
                  companyName: "",
                  contactPerson: "",
                  contactNumber: "",
                  officeAddress: "",
                  siteAddress: "",
                  natureOfBusiness: "",
                  email: "",
                  state: "",
                  city: "",
                  pincode: "",
                });
                setSearchType("");
                setSearchValue("");
                setSearchErrors({});
                setIsDetailsFetched(false);
              });
            }
          })
          .catch((err) => {
            console.error("Submit Error:", err);
          });
      });
    } else {
      console.log("Validation Errors :", newErrors);
    }
  };

  return (
    <div
      className="container-fluid px-3 px-md-4"
      style={{ maxWidth: "1400px" }}
    >
      {/* HEADER */}
      <div className="bg-black text-white d-flex align-items-center px-3 px-md-4 py-3 fw-bold rounded mb-3">
        <img
          src={Logo}
          alt="Logo"
          style={{ width: 30, borderRadius: "50%" }}
          className="me-2"
        />
        CUSTOMER ENQUIRY
      </div>

      {/* AGENT + LEAD TYPE */}
      <div className="row g-3 mb-4">
        <div className="col-lg-3 col-md-6">
          <label className="form-label small fw-semibold text-start d-block">
            Agent
          </label>
          <select className="form-select" value={agentId} disabled>
            {agents.map((a, i) => (
              <option key={i} value={a.agentid}>
                {a.agentname}
              </option>
            ))}
          </select>
        </div>

        <div className="col-lg-3 col-md-6">
          <label className="form-label small fw-semibold text-start d-block">
            Lead Type
          </label>
          <select
            className="form-select"
            value={LeadTypeID || ""}
            onChange={(e) => setLeadType(e.target.value)}
            disabled={!isDetailsFetched}
          >
            <option value="">Select Lead Type</option>
            {LeadTypeOptions.map((l, i) => (
              <option key={i} value={l.leadtypeid}>
                {l.leadtype}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* CUSTOMER DETAILS */}
      <div className="bg-white rounded shadow-sm border p-3 p-md-4 mb-4">
        <h6 className="fw-bold mb-3 text-start">Customer Details</h6>

        <div className="row g-3">
          <div className="col-lg-3 col-md-6">
            <label className="form-label small fw-semibold text-start d-block">
              Contact Number <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              placeholder="Enter Contact Number"
              value={customerDetails.contactNumber || ""}
              onChange={(e) => {
                setCustomerDetails({
                  ...customerDetails,
                  contactNumber: e.target.value,
                });
              }}
              required
            />
          </div>
          <div className="col-lg-3 col-md-6">
            <label className="form-label small fw-semibold text-start d-block">
              Company Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              placeholder="Enter Company Name"
              value={customerDetails.companyName || ""}
              onChange={(e) => {
                setCustomerDetails({
                  ...customerDetails,
                  companyName: e.target.value,
                });
              }}
              disabled={!isDetailsFetched}
              required
            />
          </div>

          <div className="col-lg-3 col-md-6">
            <label className="form-label small fw-semibold text-start d-block">
              Contact Person <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              placeholder="Enter Contact Person"
              value={customerDetails.contactPerson || ""}
              onChange={(e) => {
                setCustomerDetails({
                  ...customerDetails,
                  contactPerson: e.target.value,
                });
              }}
              disabled={!isDetailsFetched}
              required
            />
          </div>

          <div className="col-lg-3 col-md-6">
            <label className="form-label small fw-semibold text-start d-block">
              Email <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              placeholder="Enter Email"
              value={customerDetails.email || ""}
              onChange={(e) => {
                setCustomerDetails({
                  ...customerDetails,
                  email: e.target.value,
                });
              }}
              disabled={!isDetailsFetched}
              required
            />
          </div>

          <div className="col-lg-3 col-md-6">
            <label className="form-label small fw-semibold text-start d-block">
              Office Address
            </label>
            <input
              className="form-control"
              placeholder="Enter Office Address"
              value={customerDetails.officeAddress || ""}
              onChange={(e) => {
                setCustomerDetails({
                  ...customerDetails,
                  officeAddress: e.target.value,
                });
              }}
              disabled={!isDetailsFetched}
            />
          </div>

          <div className="col-lg-3 col-md-6">
            <label className="form-label small fw-semibold text-start d-block">
              Site Address
            </label>
            <input
              className="form-control"
              placeholder="Enter Site Address"
              value={customerDetails.siteAddress || ""}
              onChange={(e) => {
                setCustomerDetails({
                  ...customerDetails,
                  siteAddress: e.target.value,
                });
              }}
              disabled={!isDetailsFetched}
            />
          </div>

          <div className="col-lg-3 col-md-6">
            <label className="form-label small fw-semibold text-start d-block">
              Nature Of Business
            </label>
            <select
              className="form-select"
              value={customerDetails.natureOfBusiness || ""}
              onChange={(e) => {
                setCustomerDetails({
                  ...customerDetails,
                  natureOfBusiness: e.target.value,
                });
              }}
              disabled={!isDetailsFetched}
            >
              <option value="">Select Nature Of Business</option>
              {NatureOfBusiness.map((NatureOfBusinessObj, idx) => (
                <option
                  key={idx}
                  value={NatureOfBusinessObj.natureofbusiness.toLowerCase()}
                >
                  {NatureOfBusinessObj.natureofbusiness}
                </option>
              ))}
            </select>
          </div>

          <div className="col-lg-3 col-md-6">
            <label className="form-label small fw-semibold text-start d-block">
              State
            </label>
            <select
              className="form-select"
              value={customerDetails.state || ""}
              onChange={(e) => {
                setCustomerDetails({
                  ...customerDetails,
                  state: e.target.value,
                  city: "",
                });
                StateOnChange(e.target.value);
              }}
              disabled={!isDetailsFetched}
            >
              <option value="">Select State</option>
              {stateOptions.map((s, i) => (
                <option key={i} value={s.state}>
                  {s.state}
                </option>
              ))}
            </select>
          </div>

          <div className="col-lg-3 col-md-6">
            <label className="form-label small fw-semibold text-start d-block">
              City
            </label>
            <select
              className="form-select"
              value={customerDetails.city || ""}
              onChange={(e) =>
                setCustomerDetails({ ...customerDetails, city: e.target.value })
              }
              disabled={!customerDetails.state || !isDetailsFetched}
            >
              <option value="">Select City</option>
              {cityOptions.map((c, i) => (
                <option key={i} value={c.city}>
                  {c.city}
                </option>
              ))}
            </select>
          </div>

          <div className="col-lg-3 col-md-6">
            <label className="form-label small fw-semibold text-start d-block">
              Pincode
            </label>
            <input
              className="form-control"
              placeholder="Enter Pincode"
              value={customerDetails.pincode || ""}
              onChange={(e) => {
                setCustomerDetails({
                  ...customerDetails,
                  pincode: e.target.value,
                });
              }}
              disabled={!isDetailsFetched}
            />
          </div>
          <div className="col-lg-3 col-md-6">
            <label className="form-label small fw-semibold text-start d-block">
              GST Number
            </label>
            <input
              className="form-control"
              placeholder="Enter GST Number"
              value={customerDetails.gstnumber || ""}
              onChange={(e) => {
                setCustomerDetails({
                  ...customerDetails,
                  gstnumber: e.target.value,
                });
              }}
              disabled={!isDetailsFetched}
            />
          </div>
        </div>
      </div>

      {/* ENQUIRIES */}
      <div className="bg-white rounded shadow-sm border p-3 p-md-4 mb-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="fw-bold m-0 text-start">Customer Enquiry</h6>

          {enquiries.length < 3 && (
            <button
              className="btn btn-sm btn-outline-dark"
              onClick={addEnquiry}
              disabled={!isDetailsFetched}
            >
              + Add Enquiry
            </button>
          )}
        </div>

        {enquiries.map((enq, index) => (
          <div
            key={index}
            className="border rounded p-3 mb-3 position-relative"
            style={{ background: "#fafafa" }}
          >
            {index > 0 && (
              <button
                className="btn btn-sm btn-outline-danger position-absolute"
                style={{ top: 10, right: 10 }}
                onClick={() => removeEnquiry(index)}
                disabled={!isDetailsFetched}
              >
                Remove
              </button>
            )}

            <div className="row g-3">
              {/* Enquiry Type */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  Type of Enquiry <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  value={enq.type}
                  onChange={(e) => handleChange(index, "type", e.target.value)}
                  disabled={!isDetailsFetched}
                  required
                >
                  <option value="">Select</option>
                  {typeofEnquiries.map((t, i) => (
                    <option key={i} value={t.typeofenquiry}>
                      {t.typeofenquiry}
                    </option>
                  ))}
                </select>
              </div>

              {/* DG Fields */}
              {enq.type === "DG (Jackson Cummins)" && (
                <>
                  <div className="col-lg-3 col-md-6">
                    <label className="form-label small fw-semibold text-start d-block">
                      DG Rating <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      value={enq.dgRating}
                      onChange={(e) =>
                        handleChange(index, "dgRating", e.target.value)
                      }
                      disabled={!isDetailsFetched}
                      required
                    >
                      <option value="">Select</option>
                      {enq.dgRatingOptions.map((r, i) => (
                        <option key={i} value={r.rating}>
                          {r.rating}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <label className="form-label small fw-semibold text-start d-block">
                      Panel Type <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      disabled={!enq.dgRating || !isDetailsFetched}
                      value={enq.panelType}
                      onChange={(e) =>
                        handleChange(index, "panelType", e.target.value)
                      }
                      required
                    >
                      <option value="">Select</option>
                      {enq.panelTypeOptions.map((p, i) => (
                        <option key={i} value={p.panel}>
                          {p.panel}
                        </option>
                      ))}
                    </select>
                  </div>
                </>
              )}

              {/* Quantity */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label small fw-semibold text-start d-block">
                  Quantity <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter Quantity"
                  value={enq.quantity}
                  onChange={(e) =>
                    handleChange(index, "quantity", e.target.value)
                  }
                  disabled={!isDetailsFetched}
                  required
                />
              </div>
            </div>

            {/* Specifications */}
            <div className="mt-3">
              <label className="form-label small fw-semibold text-start d-block">
                Other Specifications
              </label>
              <textarea
                className="form-control"
                rows="2"
                placeholder="Enter Specifications"
                value={enq.specs}
                onChange={(e) => handleChange(index, "specs", e.target.value)}
                disabled={!isDetailsFetched}
              />
            </div>
          </div>
        ))}
      </div>

      {/* SUBMIT BAR */}
      <div className="position-sticky bottom-0 bg-white border-top py-3 mb-3">
        <div className="d-flex justify-content-center">
          <IconButton
            onClick={handleSubmit}
            disabled={!isDetailsFetched}
            sx={{
              px: 6,
              py: 1,
              borderRadius: "999px",
              backgroundColor: "#000",
              color: "#fff",
              fontWeight: 600,
              fontSize: "16px",
              "&:hover": { backgroundColor: "#111" },
              "&:disabled": {
                backgroundColor: "#ccc",
                color: "#666",
              },
            }}
          >
            Submit
          </IconButton>
        </div>
      </div>
    </div>
  );
}
